import React from 'react';
import {
  getLastMatch,
  getMatchStatus,
  getMatchTeamsNames,
  getTicker,
} from 'reducers/index';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { matchStatusIds } from 'constants/enum';
import MatchTicker from '../matchTicker/MatchTicker';

const hasTickerTeamNames = teamNames => {
  if (!teamNames) {
    return false;
  }

  return Boolean(teamNames.home && teamNames.away);
};

const mapStateToProps = state => ({
  hasTicker: getTicker(state),
  matchStatus: getMatchStatus(state, getLastMatch(state)),
  teamNames: getMatchTeamsNames(state, getLastMatch(state)),
});

const TickerContainer = ({
  hasTicker,
  matchStatus,
  teamNames,
}) => {
  const shouldShowTicker = hasTicker
    && matchStatus !== matchStatusIds.ended
    && hasTickerTeamNames(teamNames);

  return shouldShowTicker ? <MatchTicker /> : null;
};

TickerContainer.propTypes = {
  hasTicker: PropTypes.bool,
  matchStatus: PropTypes.string.isRequired,
  teamNames: PropTypes.object,
};

TickerContainer.defaultProps = {
  hasTicker: true,
  teamNames: {
    home: null,
    away: null,
  },
};

export default connect(mapStateToProps)(TickerContainer);
